module.exports = __webpack_public_path__ + "bg-agua.7566c080442f09c22d4b.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/images/bg-agua.png
// module id = ../../../../../src/assets/images/bg-agua.png
// module chunks = styles